import { render } from "./NonTariffMeasureCard.vue?vue&type=template&id=2b86b7d7"
import script from "./NonTariffMeasureCard.vue?vue&type=script&lang=js"
export * from "./NonTariffMeasureCard.vue?vue&type=script&lang=js"

import exportComponent from "/builds/vei/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__